module.exports = __webpack_public_path__ + "static/media/info.b00d7329.svg";